import { IColumnData } from '../models/table/columnData';
import { maskClientKey } from '../models/AccessKey';
import { columnTypes } from '../components/common/grid/constants';
import { externalIntegrationSystemLabel } from '../helpers/externalIntegrationSystem';

export const ACCESS_KEY_API_PATH = 'accessKey';

export const accessKeyHeaders = {
  CLIENT_KEY: 'accessKeys.page.view.list.clientKey',
  DESCRIPTION: 'accessKeys.page.view.list.description',
  PLATFORM: 'accessKeys.page.view.list.platform',
  ORGANIZATION: 'accessKeys.page.view.list.organization',
  CAMPAIGN_ORGANIZER: 'accessKeys.page.view.list.campaignOrganizer',
  EVENT: 'accessKeys.page.view.list.event',
  READ_ONLY: 'accessKeys.page.view.list.readOnly',
  ADVANCED: 'accessKeys.page.view.list.advancedPermissions',
  CREATED: 'accessKeys.page.view.list.createdAtLocal',
  DISABLED: 'accessKeys.page.view.list.disabled'
};

export const accessKeyColumns = {
  CLIENT_KEY: 'clientKey',
  DESCRIPTION: 'description',
  PLATFORM: 'externalIntegrationSystem',
  ORGANIZATION: 'organization.name',
  CAMPAIGN_ORGANIZER: 'campaignOrganizer.name',
  EVENT: 'event.name',
  READ_ONLY: 'readOnly',
  ADVANCED: 'advancedPermissions',
  CREATED: 'createdAtLocal',
  DISABLED: 'disabled'
};

export const accessKeysAvailableFiltersKeys = [
  'organizationId',
  'campaignOrganizerId',
  'readOnly',
  'createdAtLocal'
];

export const accessKeyDefaultOrderBy = {
  path: 'createdAtLocal',
  order: 'desc'
};

export const accessKeyColumnData: IColumnData[] = [
  {
    header: accessKeyHeaders.CLIENT_KEY,
    path: accessKeyColumns.CLIENT_KEY,
    defaultVisible: true,
    customFormatter: (v: string) => maskClientKey(v)
  },
  {
    header: accessKeyHeaders.DESCRIPTION,
    path: accessKeyColumns.DESCRIPTION,
    defaultVisible: true
  },
  {
    header: accessKeyHeaders.PLATFORM,
    path: accessKeyColumns.PLATFORM,
    defaultVisible: true,
    customFormatter: (v: string | null) => externalIntegrationSystemLabel(v)
  },
  {
    header: accessKeyHeaders.ORGANIZATION,
    path: accessKeyColumns.ORGANIZATION,
  defaultVisible: true
  },
  {
    header: accessKeyHeaders.CAMPAIGN_ORGANIZER,
    path: accessKeyColumns.CAMPAIGN_ORGANIZER,
  defaultVisible: true
  },
  {
    header: accessKeyHeaders.EVENT,
    path: accessKeyColumns.EVENT,
    defaultVisible: false
  },
  {
    header: accessKeyHeaders.READ_ONLY,
    path: accessKeyColumns.READ_ONLY,
    defaultVisible: true,
    customFormatter: (v: boolean) => (v ? 'Yes' : 'No')
  },
  {
    header: accessKeyHeaders.ADVANCED,
    path: accessKeyColumns.ADVANCED,
    defaultVisible: false
  },
  {
    header: accessKeyHeaders.DISABLED,
    path: accessKeyColumns.DISABLED,
    defaultVisible: true,
    customFormatter: (v: boolean) => (v ? 'Yes' : 'No')
  },
  {
    header: accessKeyHeaders.CREATED,
    path: accessKeyColumns.CREATED,
    defaultVisible: true,
    customFormatter: (v: string) => new Date(v).toLocaleString()
  }
];

export const accessKeyCreateVertical = [
  { name: 'accessKeys.page.create.details', description: 'accessKeys.page.create.details', isActive: true }
];
